<template>
  <div class="login-page__content pt-2 pb-12 min-h-screen bg-ma-gray-11">
    <div class="logo-wrapper my-6">
      <img src="/assets/images/shared/logo.png" class="logo-image mx-auto" />
    </div>
    <div class="gr px-0">
      <div class="login-box sm:bg-ma-0 bg-white mx-auto">
        <form
          @submit.prevent="submitForm"
          class="login-form py-8 px-6 text-ma-black-1 m-auto"
        >
          <ul>
            <li class="text-center">
              <p class="text-xl leading-6 mx-auto mb-2 font-semibold">
                Welcome!
              </p>
              <p
                class="text-ma-gray-3 sm:mb-4 text-base  font-regular sub-title"
              >
                You have been invited to join a team.
              </p>
              <p
                v-if="inviteMember.user_has_paid_plan"
                class="text-ma-gray-3 mb-6 text-base  font-regular sub-title"
              >
                We noticed that you already have a paid account. Your account
                will be immediately converted to a Team Account. Someone from
                support will contact you to issue a refund for your remaining
                account period.
              </p>
            </li>
            <li class="text-center">
              <p
                v-if="hasError"
                class="text-base font-regular sub-title text-white flex justify-center bg-ma-red-1 h-9"
              >
                {{ emailError || passwordError }}
              </p>
            </li>
            <li
              class="text-center sm:flex sm:items-stretch sm:text-sm sm:mt-4 sm:mb-3"
            >
              <div
                class="mt-3 mb-3 sm:text-left sm:my-0 text-sm sm:w-1/2 relative"
              >
                <label
                  for="user-name"
                  class="uppercase text-left sm:text-ma-black-1 font-bold block mb-1"
                  >Email</label
                >
                <input
                  id="user-name"
                  type="text"
                  v-model="email"
                  name="user-name"
                  :disabled="submitting"
                  class="w-full p-2 ma-black-1"
                  :style="{
                    paddingRight: emailError ? '55px' : null,
                  }"
                />
                <InputError
                  v-show="emailError"
                  class="absolute"
                  style="right: 5px; bottom: 7px;"
                  :message="emailError"
                />
              </div>
              <div
                class="mt-3 mb-3 sm:text-left sm:ml-4 sm:my-0 text-sm sm:w-1/2 relative"
              >
                <label
                  for="password"
                  class="uppercase text-left sm:text-ma-black-1 font-bold block mb-1"
                  >Password</label
                >
                <input
                  id="password"
                  type="password"
                  v-model="password"
                  name="password"
                  :disabled="submitting"
                  class="w-full p-2 ma-black-1"
                  :style="{
                    paddingRight: passwordError ? '55px' : null,
                  }"
                />
                <InputError
                  v-show="passwordError"
                  class="absolute"
                  style="right: 5px; bottom: 7px;"
                  :message="passwordError"
                />
              </div>
            </li>

            <li class="text-center flex items-stretch mt-8">
              <div class="text-right w-full w-1/2 sm:mr-1 pr-1">
                <button
                  type="button"
                  class="font-bold bg-ma-gray-0 hover:bg-ma-gray-1 sm:w-40 w-32 p-2 text-ma-gray-3"
                  @click="goHome"
                >
                  Don't Join Team
                </button>
              </div>
              <div class="text-left w-full sw-1/2 sm:ml-1 pl-1">
                <button
                  type="submit"
                  :disabled="submitting"
                  class="font-bold bg-ma-blue-1 sm:w-40 w-32 p-2 text-white"
                  :class="submitting ? 'opacity-50' : 'hover:bg-ma-blue-0'"
                >
                  Join Team
                </button>
              </div>
            </li>
          </ul>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import InputError from "@/components/InputError";
import { mapGetters, mapActions } from "vuex";
import { identify } from "@/utils/eventTracker"

export default {
  components: {
    InputError,
  },
  computed: {
    ...mapGetters({
      invitedByUser: "teamInvitation/invitedByUser",
      inviteMember: "teamInvitation/inviteMember",
      errorMessage1: "teamInvitation/errorMessage1",
      hasError1: "teamInvitation/hasError1",
    }),
    hasError() {
      const { emailError, passwordError } = this;
      return emailError || passwordError;
    },
  },
  data: () => ({
    emailError: "",
    passwordError: "",
    email: "",
    password: "",
    submitting: false,
  }),
  mounted() {
    this.setInviteToken({
      token: this.$route.params.token
    });
  },
  methods: {
    ...mapActions({
      signIn: "teamInvitation/signIn",
      acceptInvitationByToken: "teamInvitation/acceptInvitationByToken",
      setInviteToken: "teamInvitation/setInviteToken"
    }),
    async submitForm() {
      if (this.email == "") {
        this.emailError = "Email is required";
        return;
      }
      this.emailError = "";

      if (this.password == "") {
        this.passwordError = "Password is required";
        return;
      }

      this.passwordError = "";

      try {
        this.submitting = true;
        const payload = {
          email: this.email,
          password: this.password,
          remember_me: false,
        };
        const { data } = await this.signIn(payload);

        if (data && data.user_id) {
          identify(data.user_id.toString());
        }

        this.submitting = false;
        if (this.inviteMember.email === this.email) {
          await this.acceptInvitationByToken();
        }
        window.location.replace("/sign-up/thank-you/paid/");
      } catch (error) {
        this.submitting = false;
        if (error.response.status === 400) {
          this.emailError = error.response.data.message || error.response.data.error;
          this.passwordError = error.response.data.message || error.response.data.error;
        } else {
          // TODO : error handler
          console.log(error.response);
        }
      }
    },
    goHome() {
      window.location.replace("/browse/");
    },
  },
  metaInfo: () => ({
    bodyAttrs: { class: "login-page" },
    title: "New Member | Motion Array",
    link: [{ rel: "stylesheet", href: "/assets/site/css/team-invite.css" }],
  }),
};
</script>

<style scoped>
.login-page {
  .login-page__content {
    @screen sm {
      overflow: hidden;
    }
  }

  .logo-wrapper {
    .logo-image {
      width: 149px;
      height: 29px;
    }
  }

  .content {
    position: relative;
    background-color: #000;
    padding-top: 0;

    form {
      label {
        font-size: 13px;
      }

      @media (max-width: theme("screens.sm")) {
        .keep-me-logged {
          margin-bottom: 150px;
        }
      }
    }
  }

  .login-box >>> .login-form {
    input {
      height: 44px;
    }
    label {
      font-size: 13px;
    }
    .sub-title {
      font-weight: 500;
      align-items: center;
    }
    .ma-checkbox {
      @apply cursor-pointer;
      .wrap {
        align-items: center;
      }

      .ma-checkbox__toggle {
        width: 20px;
        height: 20px;
        font-size: 9px;
        @apply border-2 border-ma-gray-3 bg-transparent text-transparent;
      }

      @screen sm {
        &:hover {
          .ma-checkbox__toggle {
            @apply text-ma-gray-3;
          }
        }
      }

      &.ma-checkbox--checked {
        .ma-checkbox__toggle {
          @apply border-0 bg-ma-green-1 text-white;
        }
      }
    }
  }

  @screen sm {
    .login-box {
      max-width: 900px;

      form {
        max-width: 730px;
      }
    }
  }
}
</style>
